import { toast } from 'react-toastify';
import { mdiClose, mdiFileRemoveOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Col, Modal, ModalBody, ModalFooter } from 'reactstrap';
import './DeleteDocument.scss';
import { useMutation } from '@tanstack/react-query';
import { deleteDocument } from '../../../../store/apis/travelRequestService';

function DeleteDocument({
  isOpen,
  toggle,
  document,
  refetchTravelRequestDetails,
}) {
  const deleteDocumentMutation = useMutation({
    mutationFn: payload => deleteDocument(payload),
    onSuccess: () => {
      toast.success('Document deleted successfully!', {
        className: 'toast-success',
      });
      refetchTravelRequestDetails();
    },
    onError: error => {
      toast.error(error.message || 'Delete failed', {
        className: 'toast-error',
      });
    },
  });

  const handleDelete = () => {
    deleteDocumentMutation.mutate({ docId: document?.ID });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <ModalBody>
        <div className="d-flex flex-row align-items-center justify-content-between mb-3">
          <div className="delete-document-cancel-icon">
            <Icon path={mdiFileRemoveOutline} size={0.7} />
          </div>
          <div>
            <button type="button" className="btn btn-link p-0" onClick={toggle}>
              <Icon path={mdiClose} size={1} />
            </button>
          </div>
        </div>
        <div>
          <h5>Confirmation</h5>
          <p>
            Are you sure you want to delete the {document?.DocName} document?
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Col>
          <button
            type="button"
            onClick={toggle}
            className="delete-document-cancel-btn w-100"
          >
            No
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="delete-document-delete-btn w-100"
            onClick={handleDelete}
          >
            Yes, Delete
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteDocument;
